import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMoneyBillCheck: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.79175 15C9.79175 15.345 9.51175 15.625 9.16675 15.625H4.16675C2.15175 15.625 1.04175 14.515 1.04175 12.5V5.83333C1.04175 3.81833 2.15175 2.70833 4.16675 2.70833H14.1667C16.1817 2.70833 17.2917 3.81833 17.2917 5.83333V8.33333C17.2917 8.67833 17.0117 8.95833 16.6667 8.95833C16.3217 8.95833 16.0417 8.67833 16.0417 8.33333V5.83333C16.0417 4.51916 15.4809 3.95833 14.1667 3.95833H4.16675C2.85258 3.95833 2.29175 4.51916 2.29175 5.83333V12.5C2.29175 13.8142 2.85258 14.375 4.16675 14.375H9.16675C9.51175 14.375 9.79175 14.655 9.79175 15ZM3.33341 9.16666C3.33341 9.62666 3.70675 10 4.16675 10C4.62675 10 5.00008 9.62666 5.00008 9.16666C5.00008 8.70666 4.62675 8.33333 4.16675 8.33333C3.70675 8.33333 3.33341 8.70666 3.33341 9.16666ZM9.16675 6.04166C10.8901 6.04166 12.2917 7.44333 12.2917 9.16666C12.2917 10.89 10.8901 12.2917 9.16675 12.2917C7.44342 12.2917 6.04175 10.89 6.04175 9.16666C6.04175 7.44333 7.44342 6.04166 9.16675 6.04166ZM9.16675 7.29166C8.13258 7.29166 7.29175 8.13249 7.29175 9.16666C7.29175 10.2008 8.13258 11.0417 9.16675 11.0417C10.2009 11.0417 11.0417 10.2008 11.0417 9.16666C11.0417 8.13249 10.2009 7.29166 9.16675 7.29166ZM18.9584 14.1667C18.9584 16.3492 17.1826 18.125 15.0001 18.125C12.8176 18.125 11.0417 16.3492 11.0417 14.1667C11.0417 11.9842 12.8176 10.2083 15.0001 10.2083C17.1826 10.2083 18.9584 11.9842 18.9584 14.1667ZM17.7084 14.1667C17.7084 12.6733 16.4934 11.4583 15.0001 11.4583C13.5067 11.4583 12.2917 12.6733 12.2917 14.1667C12.2917 15.66 13.5067 16.875 15.0001 16.875C16.4934 16.875 17.7084 15.66 17.7084 14.1667ZM15.6001 13.03L14.6534 13.9766L14.4009 13.7242C14.1568 13.4808 13.7609 13.48 13.5167 13.7242C13.2726 13.9683 13.2726 14.3642 13.5167 14.6084L14.2109 15.3025C14.3326 15.4241 14.4926 15.485 14.6526 15.485C14.8126 15.485 14.9726 15.4242 15.0943 15.3017L16.4834 13.9125C16.7276 13.6683 16.7276 13.2725 16.4834 13.0283C16.2392 12.7866 15.8442 12.7867 15.6001 13.03Z"
      fill={color}
    />
  </svg>
);

export default IconMoneyBillCheck;
